import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import App from './App';
import profilePicture from './assets/images/profilePicture.jpeg';

// Set favicon dynamically
const setFavicon = (url: string) => {
  let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = url;
};

setFavicon(profilePicture);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
